<template>
    <div id="odometerWrapper">
        <div id="queryRunningSpinnerWrapper"  :class="[queryStillRunning ? 'appear' : '']" v-show="queryStillRunning && $store.getters.isMobile">
            <div id="queryRunningSpinner" :class="[queryStillRunning ? 'appear' : '']"></div>
        </div>
        <div id="odometerTitleBar"> 
            Vehicles Available
        </div>
        <odometer :value="vehicleCount" :places="6" :key="resizeCount"/>
    </div>
</template>

<script>
    import odometer from './odometer.vue';

    export default {
        components: {
            'odometer': odometer
        },
        computed: {
            vehicleCount() {
                return this.$store.getters.getTotalMatches;
            },
            queryStillRunning() {
                return this.$store.getters.isQueryRunning;
            },
            resizeCount() {
                return this.$store.getters.getResizeCount;
            }
        }
    }
</script>

<style>
    #odometerTitleBar {
        font-size: calc(1 * var(--vw));
        color: white;
        margin: calc(2 * var(--vh)) calc(.2 * var(--vw)); 
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inmobile #odometerTitleBar {
        font-size: calc(3.6 * var(--vw));
        margin: calc(1 * var(--vh)) 0;
    }

    .inmobile.tabletstyle .landscape  #odometerTitleBar {
        font-size: calc(2.5 * var(--vh));
    }

    #odometerWrapper {
        width: inherit;
        height: calc(12 * var(--vh));
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .inmobile #odometerWrapper {
        width: calc(36 * var(--vw));
        height: calc(8 * var(--vh));
        flex-direction: column-reverse;
        justify-content: center; /*flex-end;*//*space-evenly;*/
    }

    .inmobile.tabletstyle .landscape #odometerWrapper {
        flex-direction: row;

    }

    #queryRunningSpinnerWrapper {
        position: absolute;
        height: inherit;
        width: calc(50 * var(--vw));
        background-color: #2b2a2b;
        z-index: 1;
        opacity: 0;
        transition: opacity 1s;
        top: calc(12.5 * var(--vh));
    }

    #queryRunningSpinnerWrapper.appear {
        opacity: .8;
    }

    #queryRunningSpinner {
        position: absolute;
        left: calc((25 * var(--vw)));
        top: calc((4 * var(--vh)) - 1.25px);
        z-index: 2;
        margin: -15px 0 0 -15px;
        border: 6px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 6px solid var(--mccluskeyBlue); /*#207BD3;*/
        width: 18px;
        height: 18px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    #queryRunningSpinner.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>